export const columns: TableColumn[] = [
    {
        Header: "tableCommon.sl_no",
        accessor: "slno",
      },
      {
        Header: "applicationConfiguration.role",
        accessor: "title",
      },
      // {
      //   Header: "Status",
      //   accessor: "status",
      // },
      
]


interface TableColumn {
    Header: string;
    accessor: string;
  }